import { graphql } from '@teachino/shared-infrastructure';

export const courseBadgeFragment = graphql(`
  fragment CourseBadge on Course {
    id
    __typename
    name
    shortName
    foregroundColor
    backgroundColor
  }
`);
